<template>
    <div :class="['prosthetic reveal']">

        <div class="sectionTitle black">
            <splitter :content="localize(sectionData.title)"></splitter>
        </div>
        <div class="proContainer">
            
            <!-- Lines Container -->
            <div class="proLines">
                <div style="--index:0" class="line1 lineMotion"></div>
                <div style="--index:1" class="line2 lineMotion"></div>
                <div class="lineText l1"><span>{{localize(sectionData.level1)}}</span></div>
                <div class="lineText l2"><span>{{localize(sectionData.level2)}}</span></div>
            </div>

            <!-- Images Container -->
            <div class="proScroller" ref="scrollerRef" id="scrollerPro">
                <ul class="proImages">
                    <li class="proItem" 
                        v-for="(item, index) in sectionData.items" 
                        :style="getStyleIndex(index)"
                        :key="index">
                        <img v-bind:src="item.img" />
                        <div class="proItemName">
                            <span>{{localize(item.title)}}</span>
                        </div>
                    </li>          
                </ul>
            </div>
        </div>

        <div class="mobileNavContainer">
            <sidepager                         
                @item-change ="sidepagerOnChange"
                :skinMode="1"
                :itemIndex="selectedIndex" 
                :sectionIndex="secIndex">
            </sidepager>
        </div> 


        <!-- Desc Container -->
        <div class="proDesc">
            {{localize(sectionData.desc)}}
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import splitter from "@/views/com/splitter.vue";
import sidepager from "@/views/com/sidepager.vue";

export default {
    name: "Prosthetic",
    components:{splitter,sidepager},
    props: {
        isNavOpen: Boolean
    },
    data()
    {
        return {
            selectedIndex:0,
            secIndex:9
        }
    },
    mounted() {
        this.initScrollListener();
    },
    destroyed() {
        this.removeScrollListener();
    },
    methods:
    {
        sidepagerOnChange(index)
        {
            this.navTo(index);
        },
        initScrollListener() {
            var vm = this;
            let scroller = this.$refs.scrollerRef;
            scroller.addEventListener("scroll", vm.checkScrollPosition, false);
        },
        removeScrollListener() {
            var vm = this;
            let scroller = this.$refs.scrollerRef;
            scroller.removeEventListener("scroll", vm.checkScrollPosition);
        },
        checkScrollPosition() {
            var vm=this;
            let scroller = this.$refs.scrollerRef;
            let scrolledX = scroller.scrollLeft;
            var reveals = scroller.querySelectorAll(".proItem");
            for (var i = 0; i < reveals.length; i++) {

                let diff = Math.abs(scrolledX-reveals[i].offsetLeft);
                //if(scrolledX==reveals[i].offsetLeft){
                if(diff<10){
                    this.selectedIndex = i;
                }
            }
        },

        navTo(index)
        {
            //only on mobile !
            //alert("goto slide "+index);            
            //this.$refs.scrollerRef.scrollLeft(100);
            this.selectedIndex = index;            
            let scrollToElement = this.$refs.scrollerRef.getElementsByClassName("proItem")[index];
            scrollToElement.scrollIntoView(
                { 
                    behavior: 'smooth',
                    inline:'center',
                    block:'nearest' }
            );
            
            //var elmnt = this.$refs.scrollerRef;//document.getElementById("scroller1");
            //let sl = elmnt.scrollLeft;
            //alert("sl="+sl);
            //elmnt.scrollLeft += 50;

        },
      onIndexChange(imgIndex)
      {
        //this.plaformIndex = plaformIndex;
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["siteData","siteDataReady"]),
        sectionData(){
            return this.siteData.SECTIONS[9];
            /*
            Data sample:
            "section":"prosthetic_options",
            "title":"Prosthetic Options",
            "desc":"Consistent, concave abutment profile, designed to give more room for soft tissue ingrowth. Gold-shaded abutments minimize the reflection through the gingiva and enhance esthetic results in a thin gingival environment.",
            "img":"prosthetic_options.png",
            "level1":"Tissue level",
            "level2":"Bone level",
            "items":[
                {"title":"Image1",       "img":"img/lance/pros/pro1.png"},
                {"title":"Image2",       "img":"img/lance/pros/pro1.png"},
                {"title":"Image3",       "img":"img/lance/pros/pro1.png"},
                {"title":"Image4",       "img":"img/lance/pros/pro1.png"},
                {"title":"Image5",       "img":"img/lance/pros/pro1.png"},
                {"title":"Image6",       "img":"img/lance/pros/pro1.png"}
            ]
            */
        }

    }
};

</script>


<style>
    .prosthetic
    {      
        position:relative;
        width: 100vw;
        height: 100%;
        display: grid;
        align-items: center;
        background-color: #fafafa;
    }    


    .prosthetic .proContainer
    {
      width: 70vw;margin: auto;position: relative;
      height: 50vh;
      
    }
    .proLines
    {
        position: absolute;
        width: 100%;height: 50vh;
        top: 0px;left: 0px;
        z-index: 1000;
    }
    .prosthetic .proLines .lineMotion
    {
        width: 1%;        
        opacity: 0.1;
        transition: all 1.5s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition-delay: calc(0.2s * var(--index));
    }
    .prosthetic.active .proLines .lineMotion
    {
        opacity: 1;
        width: 100%;
    }

    .proLines .line1
    {
        position: absolute;
        top:48%;
        border-bottom: dotted 1px #888888;        
    }
    .proLines .line2
    {
        position: absolute;
        top:59.5%;
        border-bottom: dotted 1px #888888;
    }


    .proLines .lineText
    {
        position: absolute;
        font-size: 14px;
        color:#202020;
        font-weight:normal !important;
        left: -10vw;text-align: right;width: 10vw;    
        padding-right: 10px;    
        font-family: Arial, Helvetica, sans-serif
    }
    .proLines .lineText.l1{
        top:46%;
    }
    .proLines .lineText.l2{
        top:59%;
    }
    .proLines .lineText span
    {
        transform: translate(-100%,-50%);
        position: absolute;top: -50%;width: 100%;
    }

    .proScroller
    {
        position: absolute;
        width: 100%;
        top: 0px;left: 0px;
        z-index: 1010;
    }


    .proImages 
    {
        clear: both;list-style: none;  width: 100%;
        display: grid;
        justify-items: center;
        grid-template-columns: repeat(6, minmax(115px, 1fr)); 
        margin:auto;
        width:70vw;
        max-width: 1200px;
    }

    .prosthetic .proImages li    
    {
        width: 100%;height: 50vh;
        text-align: center;
        position: relative;
        opacity: 0;
        transition: all ease-in 0.8s;
        transition-delay: calc(1.2s + (0.09s * var(--index)));
        transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);    
        transform: translateY(10px);
    }
    .prosthetic.active .proImages li    
    {
        opacity: 1;
        transform: translateY(0px);
    }

    .proImages li img
    {        
        height: 50vh;width: auto;
    }
    .proImages li .proItemName
    {        
        position: absolute;
        text-align: center;
        width: 100%;
        font-size: 14px;color:#202020;font-weight: 300;
        top: calc(100% + 5px);
        opacity: 0.7;
    }
    .proImages li .proItemName span
    {
        /* padding: 10px 16px;border-radius: 20px; */
        font-family: Arial, Helvetica, sans-serif;
    }
    .prosthetic .proDesc
    {
        position: absolute;
        top:calc(75vh + 80px);
        color:#202020;
        width: 40vw;
        left: 30vw;     
        font-size: 16px;
    }



  @media (hover: hover) {
    .proImages li .proItemName span{
        transition: all ease-in 0.25s;
    }
    .proImages li:hover .proItemName{
        opacity: 1;
    }
    .proImages li:hover .proItemName span{
        /* background-color: #eeeeee; */    
    }

  }

  @media (max-width: 850px) {     
    .prosthetic
    {      
        height: auto;    
        min-height: 100vh;    
        padding: 0px 0px;
        padding-bottom: 100px;
    }        
    .prosthetic .mobileNavContainer {
        padding: 70px 0px 20px 0px;
    }    

    .prosthetic .sectionTitle
    {
        padding-top: 100px;
    }
    .prosthetic .proContainer
    {
      width: 100vw;margin: auto;
      top: 20px;
    }
    .prosthetic .proScroller
    {
        overflow-x:scroll;
        overflow-y: hidden;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }

    .prosthetic .proScroller::-webkit-scrollbar {
        display: none;
    }
    .proImages{
        width: 600vw;
        max-width: 600vw;
    }
    .proImages li{
        width: 100vw;
        height: 55vh !important;
        scroll-snap-align: start;
        scroll-snap-stop: normal;
    }
    .proLines .lineText
    {
        left:0px;text-align: left;width: 100vw;  
        padding-left: 10px;    
    }
    .proLines .lineText span
    {
        transform: translate(0,0);
        position: relative;top: -25px;
        left: 10px;
        width: 100%;
        font-size: 13px;
    }
    .prosthetic .proDesc
    {
        /*position: relative;        
        left: 10vw;
        top: 0px;  */

        width: 80vw;
        position: initial;
        padding: 20px 0px 0px 0px;
        margin: auto;        
    }
    .proLines .lineText
    {
        font-size: 15px;
    }    
    .proImages li .proItemName
    {        
        position: initial;
        font-size: 13px;
        color:#202020;font-weight: 300;
        bottom: 5px;
    }



  }  
</style>

